import { regionStore } from '../store/jotai/store';
import { dsgvoAtom, DsgvoState } from '../store/jotai/atoms/dsgvo.atom';

const STORAGE_KEY = 'rin-dsgvo';

function persistDsgvo(value: DsgvoState) {
  regionStore.set(dsgvoAtom, value);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    // ignore
  }
}

function updateCookies(
  performanceCookies: boolean,
  functionalCookies: boolean,
  targetingCookies: boolean
) {
  const current = regionStore.get(dsgvoAtom);
  persistDsgvo({
    ...current,
    performanceCookies,
    functionalCookies,
    targetingCookies,
  });
}

function setCookieOverlayState(show: boolean) {
  const current = regionStore.get(dsgvoAtom);
  persistDsgvo({ ...current, showCookieOverlay: show });
}

function get(): DsgvoState {
  return regionStore.get(dsgvoAtom);
}

export const dsgvoService = { updateCookies, setCookieOverlayState, get };
